var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("HKLModal", {
    ref: "modal",
    staticClass: "hkl-cancel-batch__modal",
    attrs: {
      okBtnAction: "yes",
      cancelBtnAction: "no",
      title: _vm.$t("tenantProjects.submission.cancelBatchMsg"),
    },
    on: { onOkClick: _vm.cancelBatch },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }